import SubscribeForm from "@/components/SubscribeForm";

const IntroSection = ({ siteSettings, isAdmin, onEditClick }) => (
  <section className="text-center py-16 relative">
    <h2 className="text-5xl font-bold text-white mb-6">
      {siteSettings.intro_title || "Uncovering The Hidden UK"}
    </h2>
    {siteSettings.intro_content && (
      <p className="text-xl text-slate-400 max-w-3xl mx-auto whitespace-pre-wrap mb-4">
        {siteSettings.intro_content}
      </p>
    )}
    <a
      href="mailto:ukdiscovered@gmail.com"
      className="text-sm text-slate-500 hover:text-blue-400 transition-colors"
    >
      Contact: ukdiscovered@gmail.com
    </a>
    <SubscribeForm />
    {isAdmin && (
      <button
        onClick={onEditClick}
        className="absolute top-4 right-4 text-slate-500 hover:text-slate-300 p-2 rounded-lg hover:bg-slate-800 transition-colors"
        title="Edit Introduction"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
      </button>
    )}
  </section>
);

export default IntroSection;
